export { Reciept as default } from './Reciept';
